// extracted by mini-css-extract-plugin
export var content = "BlogItemCard-module--content--mIKtQ";
export var date = "BlogItemCard-module--date--tlhMZ";
export var leadMediaThumb = "BlogItemCard-module--leadMediaThumb--91vXy";
export var orange = "BlogItemCard-module--orange--+tGqO";
export var root = "BlogItemCard-module--root--ORC+T";
export var title = "BlogItemCard-module--title--Jn0GG";